import { useState } from 'react';
import {
  TextField,
  Button,
  Typography,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { toast } from 'react-toastify';
import auth from '../../../services/AuthService';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ToastMessage from '@/components/toasts/ToastMessage';

export default function ChangePasswordForm() {
  const [showPasswords, setShowPasswords] = useState({
    showOldPassword: false,
    showNewPassword: false,
    showConfirmNewPassword: false,
  });

  const [profile, setProfile] = useState({
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfile({ ...profile, [name]: value });
  };

  const changePassword = async () => {
    const { oldPassword, newPassword, confirmNewPassword } = profile;

    if (!oldPassword || !newPassword || !confirmNewPassword) {
      toast.error('Bitte füllen Sie alle Felder aus');
      return;
    }
    try {
      await auth.put(
        '/me/changePassword',
        JSON.stringify({ oldPassword, newPassword, confirmNewPassword }),
      );
      toast.success(
        <ToastMessage title="Erfolg" subtitle="Passwort geändert" />,
      );
    } catch (e) {
      toast.error(
        <ToastMessage title="Fehler" subtitle={e?.response?.data?.message} />,
      );
    } finally {
      setProfile({
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: '',
      });
    }
  };
  return (
    <>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 'bold',
          marginBottom: '20px',
        }}
      >
        Passwort ändern
      </Typography>

      <TextField
        required
        type={showPasswords.showOldPassword ? 'text' : 'password'}
        value={profile.oldPassword}
        label="Altes Passwort"
        variant="outlined"
        fullWidth
        autoComplete="current-password"
        name="oldPassword"
        onChange={handleInputChange}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() =>
                  setShowPasswords((prev) => ({
                    ...prev,
                    showOldPassword: !prev.showOldPassword,
                  }))
                }
                edge="end"
              >
                {showPasswords.showOldPassword ? (
                  <VisibilityIcon />
                ) : (
                  <VisibilityOffIcon />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <TextField
        required
        type={showPasswords.showNewPassword ? 'text' : 'password'}
        value={profile.newPassword}
        label="Neues Passwort"
        variant="outlined"
        fullWidth
        autoComplete="new-password"
        name="newPassword"
        onChange={handleInputChange}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() =>
                  setShowPasswords((prev) => ({
                    ...prev,
                    showNewPassword: !prev.showNewPassword,
                  }))
                }
                edge="end"
              >
                {showPasswords.showNewPassword ? (
                  <VisibilityIcon />
                ) : (
                  <VisibilityOffIcon />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <TextField
        required
        type={showPasswords.showConfirmNewPassword ? 'text' : 'password'}
        value={profile.confirmNewPassword}
        label="Neues Passwort erneut eingeben"
        variant="outlined"
        fullWidth
        autoComplete="new-password"
        name="confirmNewPassword"
        onChange={handleInputChange}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() =>
                  setShowPasswords((prev) => ({
                    ...prev,
                    showConfirmNewPassword: !prev.showConfirmNewPassword,
                  }))
                }
                edge="end"
              >
                {showPasswords.showConfirmNewPassword ? (
                  <VisibilityIcon />
                ) : (
                  <VisibilityOffIcon />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <Button variant="outlined" onClick={changePassword}>
        Ändern
      </Button>
    </>
  );
}
